var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sectionVisible
    ? _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "section-title",
                    {
                      attrs: { "title-type": "subtitle" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("delete-element-icon", {
                                  on: {
                                    delete: function ($event) {
                                      return _vm.handleDeleteExistingMortgage()
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1512989275
                      ),
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatNumeral")(
                              _vm.existingMortgageIndex + 1,
                              "0o"
                            )
                          ) +
                          " Mortgage\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.otherPropertyExistingMortgageInterestRateVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("percentage-field", {
                        attrs: {
                          value: _vm.existingMortgageInterestRate,
                          label: _vm.$t(
                            "application-standalone.questions.interestRate"
                          ),
                          placeholder: _vm.$t("application-form.interest-rate"),
                          validator: _vm.getValidator(
                            "existingMortgageInterestRate"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageInterestRate = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageRateTypeVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageRateType,
                          options: _vm.mortgageRateTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.rateType"
                          ),
                          placeholder: _vm.$t("application-form.rate-type"),
                          validator: _vm.getValidator(
                            "existingMortgageRateType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageRateType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageFrequencyVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageFrequency,
                          options: _vm.mortgageFrequencyOptions,
                          label: _vm.$t(
                            "application-standalone.questions.frequency"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.frequency"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageFrequency"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageFrequency = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgagePaymentAmountVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgagePaymentAmount,
                          label: _vm.$t(
                            "application-standalone.questions.paymentAmount"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.paymentAmount"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgagePaymentAmount"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgagePaymentAmount = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageLenderVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.existingMortgageLender,
                          label: _vm.$t(
                            "application-standalone.questions.lender"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.pages.properties.provideLenderName"
                          ),
                          validator: _vm.getValidator("existingMortgageLender"),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageLender = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageBalanceRemainingVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgageBalanceRemaining,
                          label: _vm.$t(
                            "application-standalone.questions.balanceRemaining"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.balanceRemaining"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageBalanceRemaining"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageBalanceRemaining = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageMortgageTypeVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageMortgageType,
                          options: _vm.mortgageTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.mortgageType"
                          ),
                          placeholder: _vm.$t("application-form.mortgage-type"),
                          validator: _vm.getValidator(
                            "existingMortgageMortgageType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageMortgageType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageOrigAmountVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgageOrigAmount,
                          label: _vm.$t(
                            "application-standalone.questions.origAmount"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.origAmount"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageOrigAmount"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageOrigAmount = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageMaturityDateVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("date-field", {
                        attrs: {
                          value: _vm.existingMortgageMaturityDate,
                          label: _vm.$t(
                            "application-standalone.questions.maturityDate"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageMaturityDate"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageMaturityDate = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherPropertyExistingMortgageTermTypeVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageTermType,
                          options: _vm.mortgageTermTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.termType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.termType"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageTermType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageTermType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.otherPropertyExistingMortgagePayoffVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgagePayoff,
                          options: _vm.mortgagePayoffOptions,
                          label: _vm.$t(
                            "application-standalone.questions.payoff"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.payoff"
                          ),
                          validator: _vm.getValidator("existingMortgagePayoff"),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgagePayoff = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.otherPropertyExistingMortgageLoanTypeVisibility
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageLoanType,
                          options: _vm.mortgageLoanTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.loanType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.loanType"
                          ),
                          validator: _vm.getValidator(
                            "existingMortgageLoanType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageLoanType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }